export default {
  // Page titles
  title: "Sample Quota",
  detailTitle: "Sample Quota Details",

  // Table columns
  shopInfo: "Shop Info",
  supplierName: "Supply Chain",
  activeProductCount: "Active Products",
  quotaLessThan30: "Quota ≤ 30",
  quotaEqualsZero: "Quota = 0",
  follower: "Merchant PC",
  activeProducts: "Active Products",
  view: "View",

  // Detail table
  productInfo: "Product Info",
  activityInfo: "Activity Info",
  remainingQuota: "Remaining Quota",
  activityId: "Activity ID",
  copySuccess: "Activity link copied",
  copyLink: "Copy activity link",
  zeroQuotaWarning: "Application restricted. Contact merchant to replenish sample quota!",
  lowQuotaWarning: "Quota running low. Contact merchant to replenish sample quota!",

  // Search form
  shopName: "Shop Name",
  shopCode: "Shop ID",
  inputShopName: "Enter shop name",
  inputShopCode: "Enter shop ID",
  inputSupplierName: "Enter supply chain name",
  selectFollower: "Select merchant PC",

  // Others
  onlyShowLowQuota: "Only show shops needing quota replenishment",

  // Alert messages
  alertMessage: "Products with zero sample quota cannot be applied for samples",
  alertDescription: "Please notify merchants to replenish quota promptly.",
  howToReplenish: "How to replenish?"
};
